import { useEffect } from "react";
import { registerWebMcpTools } from "./registerWebMcpTools";
import type { RegisterWebMcpToolsOptions } from "./registerWebMcpTools";
import type { WebMcpToolDefinition } from "./types";

/**
 * Register read-only WebMCP tools for the lifetime of the mounting component.
 *
 * Registration is watched (the API may inject after load) and torn down on
 * unmount. `tools`/`options` are captured on mount — pages register tools from
 * static content, so re-registering on every render is neither needed nor wanted.
 */
export const useWebMcpTools = (
  tools: WebMcpToolDefinition[],
  options?: RegisterWebMcpToolsOptions,
): void => {
  useEffect(() => {
    const { teardown } = registerWebMcpTools(tools, options);
    return teardown;
    // Mount-once by design: tools come from static content and are registered
    // for the component's lifetime, so `tools`/`options` are intentionally not
    // dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
